import React, {FC, useState} from "react";
import PrivacyModal from "../modal/PrivacyModal";
import CaliforniaPrivacy from "../modal/CaliforniaPrivacy";
import TermsOfUse from "../modal/TermsOfUse";
import AccessibilityModal from "../modal/Accessibility";

const IceFooter: FC = () => {
    const [modalState, setModalState] = useState({
        show: false,
        type: "",
    });

    const handleCloseModal = () => {
        setModalState({
            show: false,
            type: "",
        });
    };

    return (
        <div className="w-full bg-text-0 p-3  relative">
            <div className="footer_outer m-auto font-semibold">
                <div className="flex pl-10 items-center gap-6">
                    {/* Copyright */}
                    <span className="sm:mt-0  text-surface-0">
        © {new Date().getFullYear()} Intercontinental Exchange, Inc.
    </span>
                    <a
                        href="https://www.ice.com/privacy-security-center#black-knight-privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cursor-pointer bottom_font text-surface-0 hover:underline"
                    >
                        Privacy
                    </a>
                    <a
                        href="https://www.ice.com/privacy-security-center/terms-of-use"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cursor-pointer bottom_font text-surface-0 hover:underline"
                    >
                        Terms of Use
                    </a>
                </div>

            </div>
        </div>
    );
};

export default IceFooter;
